import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { EconomicGroupFlowService } from "../../service/economic-group-flow.service";
import { FlashMessagesService } from "angular2-flash-messages/module";
import { Router, ActivatedRoute } from "@angular/router";

@Component({
  selector: 'app-economic-group-flow',
  templateUrl: './economic-group-flow.component.html',
  styleUrls: ['./economic-group-flow.component.scss'],
  providers: [EconomicGroupFlowService]
})
export class EconomicGroupFlowComponent implements OnInit {

  economicGroupForm: FormGroup;
  private economicGroupClassifications;
  private profileList;
  private economicGroupFlows;
  private selectedClassificationID;
  private lastEconomicGroupFlow = {
    "Nivel": 0,
    "ID": '',
    "PerfilId": '',
    "ClassificacaoGrupoEconomicoId": '',
    "Ativo": true,
  }

  constructor(fb: FormBuilder, private economicGroupFlowService: EconomicGroupFlowService, private flashMessagesService: FlashMessagesService, private router: Router, private route: ActivatedRoute) {
    this.economicGroupForm = fb.group({
      'Nivel': ['', Validators.required],
      'Perfil': ['', Validators.required],
      'ClassificacaoGrupoEconomicoId': ['']
    });
  }

  ngOnInit() {
    this.getEconomicGroupClassifications();
  }

  onSelectClassification(id) {
    this.selectedClassificationID = id;
    this.economicGroupForm.controls.ClassificacaoGrupoEconomicoId.setValue(this.selectedClassificationID);
    this.getProfileList();
    this.getEconomicGroupFlows();
  }

  getProfileList() {
    this.economicGroupFlowService.listProfile().subscribe(result => {
      this.profileList = result.Result.filter(c => c.Descricao != "Analista de Crédito");
      console.log('this.profileList)', this.profileList);
    }, error => {
      console.log(error);
    });
  }

  getEconomicGroupClassifications() {
    this.economicGroupFlowService.getEconomicGroupClassifications().subscribe(result => {
      this.economicGroupClassifications = result.Result;
    }, error => {
      console.log(error);
    });
  }

  getEconomicGroupFlows() {
    this.economicGroupFlowService.getEconomicGroupFlows(this.selectedClassificationID).subscribe(result => {
      if (result.Result) {
        this.economicGroupFlows = result.Result;
        if (this.economicGroupFlows.length > 0) {
          this.lastEconomicGroupFlow = this.economicGroupFlows[this.economicGroupFlows.length - 1];
          this.economicGroupForm.controls.Nivel.setValue(this.lastEconomicGroupFlow.Nivel + 1);
        } else {
          this.lastEconomicGroupFlow.Nivel = 0;
        }
      } else {
        this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
      }
      this.economicGroupForm.controls.Nivel.setValue(this.lastEconomicGroupFlow.Nivel + 1);
    }, error => {
      console.log(error);
    });
  }

  addGroupFlow() {
    this.economicGroupFlowService.insertEconomicGroupFlow(this.economicGroupForm.value).subscribe(result => {
      if (result.Success) {
        this.flashMessagesService.show('Nível cadastrado com sucesso.', { cssClass: 'alert-success', timeout: 6000 });
        this.getEconomicGroupFlows();
        this.economicGroupForm.controls.Usuario.reset();
      } else {
        this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
      }
    }, error => {
      console.log(error);
    });
  }

  deleteGroupFlow() {
    this.economicGroupFlowService.deleteEconomicGroupFlow(this.lastEconomicGroupFlow.ID).subscribe(result => {
      if (result.Success) {
        this.flashMessagesService.show('Nível excluído com sucesso.', { cssClass: 'alert-success', timeout: 6000 });
        this.getEconomicGroupFlows();
        this.economicGroupForm.controls.Usuario.reset();
      } else {
        this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
      }
    }, error => {
      console.log(error);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/economic-group-flow/component/economic-group-flow/economic-group-flow.component.ts